"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableIMap = void 0;
var mobx_1 = require("mobx");
var ObservableIMap = /** @class */ (function () {
    function ObservableIMap() {
        this._values = mobx_1.observable.map({}, { deep: false });
    }
    ObservableIMap.prototype.get = function (key) {
        return this._values.get(key);
    };
    ObservableIMap.prototype.set = function (key, value) {
        this._values.set(key, value);
    };
    ObservableIMap.prototype.has = function (key) {
        return this._values.has(key);
    };
    ObservableIMap.prototype.keys = function () {
        return Array.from(this._values.keys());
    };
    ObservableIMap.prototype.values = function () {
        return Array.from(this._values.values());
    };
    ObservableIMap.prototype.clear = function () {
        this._values.clear();
    };
    ObservableIMap.prototype.delete = function (key) {
        this._values.delete(key);
    };
    Object.defineProperty(ObservableIMap.prototype, "size", {
        get: function () {
            return this._values.size;
        },
        enumerable: false,
        configurable: true
    });
    return ObservableIMap;
}());
exports.ObservableIMap = ObservableIMap;
//# sourceMappingURL=observable.map.js.map